import { render, staticRenderFns } from "./DetailsImageField.vue?vue&type=template&id=214d16ed&scoped=true"
import script from "./DetailsImageField.vue?vue&type=script&lang=ts"
export * from "./DetailsImageField.vue?vue&type=script&lang=ts"
import style0 from "./DetailsImageField.vue?vue&type=style&index=0&id=214d16ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214d16ed",
  null
  
)

export default component.exports